/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ProfileState } from 'store/modules/profile_store/types';
import FeedbackModal from 'components/molecules/feedback_modal';
import TopBannerInSample from 'components/molecules/top_banner_in_sample';
import TopBannerAmbassadorInvite from 'components/molecules/top_banner_ambassador_invite';
import { useAmbassadorInviteBanner } from 'hooks/useAmbassadorInviteBanner';
import { PanelState } from 'store/modules/panel_store/types';
import PublicRoutes from 'services/public_routes';
import PrivateRoutes from 'services/private_routes';
import { isConlicitasegAllowedRoute } from 'services/conlicitaseg_only_routes';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import useFidelizeLoginRedirect from 'hooks/useFidelizeLoginRedirect';
import SideBar from 'components/organisms/side_bar';
import { BiddingChatState } from 'store/modules/bidding_chat/types';
import BiddingChat from 'components/organisms/bidding_chat';
import tabId from 'services/tabId';
import Header from 'components/organisms/header';
import BiddingSummary from 'components/organisms/bidding_summary';
import { BiddingSummaryState } from 'store/modules/bidding_summary_store/types';
import UndoToast from 'components/molecules/undo_toast';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';
import { blockedByReleasedServices } from 'services/selected_companies';
import { refreshProfile } from 'store/modules/profile_store/actions';
import { isCnlChat, isTawk } from 'services/support_chat';
import AuthLayout from '../pages/_layout/auth';
import DefaultLayout from '../pages/_layout/default';
import { ApplicationState } from '../store';

const ReleasedServicesBlocked = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(refreshProfile());
  }, [dispatch]);

  return (
    <div className="page-container">
      <BlockedSubscriptionRepresentant />
    </div>
  );
};

// Sem <Switch> em routes/index.tsx, todas as rotas caem no guard juntas: um <Redirect> por rota
// estoura o limite do Safari (100 replaceState em 10 s) e a página fica branca no iOS.
const RedirectOnce: React.FC<{ to: string }> = ({ to }) => {
  const history = useHistory();
  useEffect(() => {
    if (history.location.pathname !== to.split(/[?#]/)[0]) history.replace(to);
  }, [history, to]);

  return null;
};

interface OwnProps {
  isPrivate?: boolean;
  component: React.ComponentClass;
}
declare global {
  interface Window {
    __tawkTestLoaded?: boolean;
  }
}

/**
 * Telefone para o CNL Chat: DDD + número, somente dígitos (ex.: 51994129999).
 * Sem número, devolve '' (nem o DDD vai) e o atributo segue vazio.
 */
function formataTelefoneCnlChat(ddd?: string, numero?: string): string {
  const digitosNumero = (numero ?? '').replace(/\D/g, '');
  if (!digitosNumero) return '';
  return `${(ddd ?? '').replace(/\D/g, '')}${digitosNumero}`;
}

const RouteWrapper: React.FC<any> = ({
  isPrivate = false,
  component: Component,
  ...rest
}: OwnProps) => {
  const {
    REACT_APP_TAWK_TO_URL,
    REACT_APP_CNLCHAT_URL,
    REACT_APP_CNLCHAT_PUBLIC_KEY,
    REACT_APP_CNLCHAT_SYSTEM_ID,
  } = process.env;
  const { pathname, search } = useLocation();

  const isSigned = useSelector<ApplicationState, boolean>(
    (state) => state.storage.profile.profile.isSigned,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const fidelizeDestination = useFidelizeLoginRedirect();
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const showAmbassadorInvite = useAmbassadorInviteBanner();
  const { bidding_chat } = useSelector<ApplicationState, BiddingChatState>(
    (state) => state.session.bidding_chat,
  );
  const { bidding_summary } = useSelector<ApplicationState, BiddingSummaryState>(
    (state) => state.session.bidding_summary,
  );
  /** Modal e id do resumo vêm do Redux — evita useEffect atrasado e biddingId === 0 no primeiro paint. */
  const [biddingChatModalOpened, setBiddingChatModalOpened] = useState<boolean>(false);
  const [biddingChatBiddingId, setBiddingChatBiddingId] = useState<number>(0);

  const summaryTabState = bidding_summary.current_bidding_summary[tabId()];
  const biddingSummaryModalOpened = Boolean(summaryTabState?.modalOpened);
  const biddingSummaryBiddingId = Number(summaryTabState?.currentBiddingId ?? 0);

  useEffect(() => {
    if (!bidding_chat.current_chat[tabId()]) return;

    if (!bidding_chat.current_chat[tabId()].modalOpened) return setBiddingChatModalOpened(false);

    if (bidding_chat.current_chat[tabId()].modalOpened) return setBiddingChatModalOpened(true);
  }, [bidding_chat.current_chat[tabId()]]);

  useEffect(() => {
    if (!bidding_chat.current_chat[tabId()]) return;

    setBiddingChatBiddingId(bidding_chat.current_chat[tabId()].currentBiddingId);
  }, [bidding_chat.current_chat[tabId()]]);

  useEffect(() => {
    if (isSigned || pathname === '/onboarding') {
      document.body.classList.add('hide-tallos');
    } else {
      document.body.classList.remove('hide-tallos');
      document.querySelectorAll('.widget-visible').forEach((el) => {
        el.classList.remove('widget-visible');
      });
    }
    return () => {
      document.querySelectorAll('.widget-visible').forEach((el) => {
        el.classList.add('widget-visible');
      });
      document.body.classList.remove('hide-tallos');
    };
  }, [isSigned, pathname]);

  /**
   * CNL Chat — widget próprio, injetado apenas na área autenticada. O loader se
   * auto-protege contra dupla execução (__CNL_CHAT_LOADED__), então aqui basta
   * não repetir a tag.
   */
  useEffect(() => {
    if (!isCnlChat) return;
    if (!isSigned) return;
    if (!REACT_APP_CNLCHAT_URL || !REACT_APP_CNLCHAT_PUBLIC_KEY || !REACT_APP_CNLCHAT_SYSTEM_ID)
      return;
    if (!profile?.clientId || !profile?.email) return;
    if (pathname === '/cadastro') return;

    if (document.querySelector(`script[src="${REACT_APP_CNLCHAT_URL}"]`)) return;

    /** Nome autenticado. Sem ele o widget cai no pré-chat e pede os dados de novo. */
    const nome = profile.name || '';
    if (!nome) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = REACT_APP_CNLCHAT_URL;
    script.setAttribute('data-public-key', REACT_APP_CNLCHAT_PUBLIC_KEY);
    script.setAttribute('data-system-id', REACT_APP_CNLCHAT_SYSTEM_ID);
    script.setAttribute('data-controle', String(profile.clientId));
    script.setAttribute('data-nome', nome);
    script.setAttribute('data-email', profile.email);
    script.setAttribute(
      'data-telefone',
      formataTelefoneCnlChat(profile.ddd_cellphone, profile.cellphone),
    );

    document.body.appendChild(script);
  }, [isSigned, profile?.clientId]);

  /** Tawk.to — comportamento anterior, mantido para rollback pela env. */
  useEffect(() => {
    if (!isTawk) return;
    if (!profile?.name || !profile?.clientId || !profile?.email) return;
    if (pathname === '/cadastro') return;

    if ((window as any).__tawkLoaded) return;

    const Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_API = Tawk_API;
    (window as any).Tawk_LoadStart = new Date();

    Tawk_API.visitor = {
      name: `${profile.name} - ${profile.clientId}`,
      email: profile.email,
    };

    Tawk_API.onLoad = function () {
      Tawk_API.setAttributes({
        controle: profile.clientId,
        acesso: profile.alfa_tester
          ? 'Alfa Tester'
          : profile.beta_tester
          ? 'Beta Tester'
          : 'Normal',
        venda: profile.sale_situation,
        responsavel: profile.responsible,
        widget_version: 'antigo',
      });
    };

    const script = document.createElement('script');
    script.async = true;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    script.src = REACT_APP_TAWK_TO_URL as string;

    document.body.appendChild(script);
    (window as any).__tawkLoaded = true;
  }, [profile?.clientId]);

  useEffect(() => {
    if (isSigned) {
      const saved = localStorage.getItem('redirectAfterLogin');

      if (saved && saved.split('?')[0] === pathname) {
        localStorage.removeItem('redirectAfterLogin');
      }
    }
  }, [isSigned, pathname]);

  const Layout = isSigned ? DefaultLayout : AuthLayout;

  let isPrivateRoute = false;
  if (pathname && PrivateRoutes.filter((route: string) => pathname.includes(route))?.length > 0)
    isPrivateRoute = true;

  const isPublicRoute = PublicRoutes.includes(pathname);

  // if (!isSigned && isPrivate && !isPublicRoute) return <Redirect to="/" />;

  if (!isSigned && isPrivate && !isPublicRoute) {
    const alreadySaved = localStorage.getItem('redirectAfterLogin');

    if (!alreadySaved && pathname !== '/') {
      localStorage.setItem('redirectAfterLogin', `${pathname}${search}`);
    }

    return <RedirectOnce to="/" />;
  }
  // se já estiver logado, não precisa fazer login denovo
  // if (isSigned && !isPrivateRoute) return <Redirect to="/painel" />;

  if (isSigned && !isPrivateRoute) {
    const savedRedirect = localStorage.getItem('redirectAfterLogin');
    const deepLink = savedRedirect && savedRedirect !== '/painel' ? savedRedirect : null;
    const redirectTo = deepLink || fidelizeDestination || '/painel';
    return <RedirectOnce to={redirectTo} />;
  }

  if (isSigned && isOnlyConlicitaseg && !isConlicitasegAllowedRoute(pathname)) {
    return <Redirect to="/painel" />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <FeedbackModal />
          <BiddingChat
            showModal={biddingChatModalOpened}
            biddingId={biddingChatBiddingId}
            isSummaryOpen={biddingSummaryModalOpened}
          />
          <BiddingSummary
            showModal={biddingSummaryModalOpened}
            biddingId={biddingSummaryBiddingId}
            isChatOpen={biddingChatModalOpened}
          />

          {isSigned && <Header />}
          {isSigned && <UndoToast />}

          {isSigned && !isOnlyConlicitaseg && profile.in_sample && <TopBannerInSample />}
          {isSigned && !isOnlyConlicitaseg && panel?.registration_type_validation === 1 && (
            <TopBannerInSample />
          )}
          {showAmbassadorInvite && <TopBannerAmbassadorInvite />}

          {!isSigned && pathname === '/minhas_licitacoes/shares' && <SideBar offlineMode />}
          {!isSigned && pathname === '/minhas_licitacoes/shares' && <Header offlineMode />}
          {isSigned && blockedByReleasedServices(profile, pathname) ? (
            <ReleasedServicesBlocked />
          ) : (
            <Component {...props} />
          )}
          {panel?.registration_type_validation === 3 && pathname !== '/' && (
            <Redirect to="/cadastrar" />
          )}
          {panel?.registration_type_validation === 5 && pathname !== '/' && (
            <Redirect to="/cadastrar" />
          )}
        </Layout>
      )}
    />
  );
};

export default RouteWrapper;
